import React from "react";
import CartProvider from "../../providers/CartProvider";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppProps } from "../BaseApp";
import CustomToastContainer from "../../../shared/ui/custom-toast-container";
import { QueryClientProvider } from "@tanstack/react-query";
import AnalyticsProvider from "app/providers/AnalyticsProvider";
import Samples from "../../../widgets/samples";
import { queryClient } from "../queryClient";

const App: React.FC<AppProps> = (props, context) => {
  const getBasename = (): string => {
    return props.configuration.basename || "kleurstaalmodule";
  };
  return (
    <div className="gg">
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AnalyticsProvider>
            <CartProvider>
              <CustomToastContainer />
              <Routes>
                <Route path={getBasename()} element={<Samples />} />
              </Routes>
            </CartProvider>
          </AnalyticsProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
